import React, { Component } from "react";
import AllStates from "../AllStates";

class LegislationModal extends Component {
  item = {};
  handleChange = e => {
    this.item[e.target.name] = e.target.value;
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.submit(this.item);
  };

  render() {
    if (this.props.legislationID) {
      this.item = this.props.legislationItems.find(
        l => l.legislative_id === this.props.legislationID
      );
    } else {
      for (let k in this.props.legislationItems[0]) {
        this.item[k] = "";
      }
      /* To make sure it satisfy the non-null constraints*/
      this.item["legislative_id"] = 0;
      this.item["state_id"] = 1;
      this.item["is_applied_any_state_gov_agency"] = "false";
    }
    const isAdmin =
        localStorage.getItem("role") &&
        JSON.parse(localStorage.getItem("role")).some(
            r => r.name === "ROLE_ADMIN"
        );
    return (
      <div>
        <button
          className="btn btn-primary"
          onClick={this.props.closeModalHandler}
        >
          Back
        </button>
        <small className={"d-block"}>
          <span style={{ color: "red" }}>*</span> required
        </small>
        <form id="legislative_form" onSubmit={this.handleSubmit}>
          <div className="form-group row">
            <input
              disabled
              type="hidden"
              className="form-control"
              id="legislative_id"
              name="legislative_id"
              defaultValue={this.item.legislative_id}
              readOnly
            />
            <label
              htmlFor="state"
              className="col-sm-3 col-form-label leftAlign required"
            >
              State
            </label>
            <div className="col-md-3">
              <select
                className="form-control"
                id="state_id"
                required
                name="state_id"
                defaultValue={
                  this.item.state_id
                    ? AllStates[this.item.state_id - 1].state_name
                    : "Alaska"
                }
                onChange={this.handleChange}
                disabled={!isAdmin}
              >
                {AllStates.map(state => (
                  <option key={state.state_id}>{state.state_name}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="bill_id"
              className="col-sm-3 col-form-label leftAlign"
            >
              Bill ID
            </label>
            <div className="col-md-3">
              <input
                type="text"
                maxLength="200"
                className="form-control"
                id="bill_id"
                name="bill_id"
                defaultValue={this.item.bill_id}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="p3_authorized"
              className="col-sm-3 col-form-label leftAlign"
            >
              P3 Authorized
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                maxLength="500"
                id="p3_authorized"
                name="p3_authorized"
                defaultValue={this.item.p3_authorized}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="p3_transportation_sector_authorized"
              className="col-sm-3 col-form-label leftAlign"
            >
              P3 Transportation Sector Authorized
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                maxLength="4000"
                id="p3_transportation_sector_authorized"
                name="p3_transportation_sector_authorized"
                defaultValue={this.item.p3_transportation_sector_authorized}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="statutory_citation"
              className="col-sm-3 col-form-label leftAlign"
            >
              Statutory Citation
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                maxLength="500"
                id="statutory_citation"
                name="statutory_citation"
                defaultValue={this.item.statutory_citation}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="statutory_citation_url"
              className="col-sm-3 col-form-label leftAlign"
            >
              Statutory Citation Url
            </label>
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                id="statutory_citation_url"
                name="statutory_citation_url"
                maxLength="4000"
                defaultValue={this.item.statutory_citation_url}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="statutory_citation_2"
              className="col-sm-3 col-form-label leftAlign"
            >
              Statutory Citation #2
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                id="statutory_citation_2"
                name="statutory_citation_2"
                maxLength="4000"
                defaultValue={this.item.statutory_citation_2}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="statutory_citation_2_url"
              className="col-sm-3 col-form-label leftAlign"
            >
              Statutory Citation Url #2
            </label>
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                id="statutory_citation_2_url"
                maxLength="4000"
                name="statutory_citation_2_url"
                defaultValue={this.item.statutory_citation_2_url}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="p3_enactment_year"
              className="col-sm-3 col-form-label leftAlign"
            >
              P3 Enactment Year
            </label>
            <div className="col-md-3">
              <input
                type="text"
                className="form-control"
                id="p3_enactment_year"
                name="p3_enactment_year"
                defaultValue={this.item.p3_enactment_year}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="project_types_authorized"
              className="col-sm-3 col-form-label leftAlign"
            >
              Project Type Authorized
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                id="project_types_authorized"
                name="project_types_authorized"
                defaultValue={this.item.project_types_authorized}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="db_authorized"
              className="col-sm-3 col-form-label leftAlign"
            >
              Database Authorized
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                id="db_authorized"
                name="db_authorized"
                defaultValue={this.item.db_authorized}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="sunset_provisions"
              className="col-sm-3 col-form-label leftAlign"
            >
              Sunset Provisions
            </label>
            <div className="col-md-3">
              <input
                maxLength="500"
                className="form-control"
                id="sunset_provisions"
                name="sunset_provisions"
                defaultValue={this.item.sunset_provisions}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="sunset_provisions_short_date"
              className="col-sm-3 col-form-label leftAlign"
            >
              Sunset Provision (Short Date)
            </label>
            <div className="col-md-3">
              <input
                type="date"
                className="form-control"
                id="sunset_provisions_short_date"
                name="sunset_provisions_short_date"
                defaultValue={this.item.sunset_provisions_short_date}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="toll_conversion_allowed"
              className="col-sm-3 col-form-label leftAlign"
            >
              Toll Conversions Allowed
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                id="toll_conversion_allowed"
                name="toll_conversion_allowed"
                defaultValue={this.item.toll_conversion_allowed}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="concession_term_limit"
              className="col-sm-3 col-form-label leftAlign"
            >
              Concession Term Limit
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="concession_term_limit"
                id="concession_term_limit"
                defaultValue={this.item.concession_term_limit}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="prohibits_noncomplete_clauses"
              className="col-sm-3 col-form-label leftAlign"
            >
              Prohibited Non-complete Clauses
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="prohibits_noncomplete_clauses"
                id="prohibits_noncomplete_clauses"
                defaultValue={this.item.prohibits_noncomplete_clauses}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
            `
          </div>

          <div className="form-group row">
            <label
              htmlFor="p3_allowed_facilities"
              className="col-sm-3 col-form-label leftAlign"
            >
              P3 Allowed For Both Existing And New Facilities
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="p3_allowed_facilities"
                id="p3_allowed_facilities"
                defaultValue={this.item.p3_allowed_facilities}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="hot_operation_allowed"
              className="col-sm-3 col-form-label leftAlign"
            >
              Hot Operations Allowed
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="hot_operation_allowed"
                id="hot_operation_allowed"
                defaultValue={this.item.hot_operation_allowed}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="state_legislative_approvals"
              className="col-sm-3 col-form-label leftAlign"
            >
              State Legislative Approvals
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="state_legislative_approvals"
                id="state_legislative_approvals"
                defaultValue={this.item.state_legislative_approvals}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="other_agency_approvals"
              className="col-sm-3 col-form-label leftAlign"
            >
              Other Agency Approvals
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="other_agency_approvals"
                id="other_agency_approvals"
                defaultValue={this.item.other_agency_approvals}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="p3_advisory_body"
              className="col-sm-3 col-form-label leftAlign"
            >
              P3 Advisory Body
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                id="p3_advisory_body"
                name="p3_advisory_body"
                defaultValue={this.item.p3_advisory_body}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="unsolicited_proposal_allowed"
              className="col-sm-3 col-form-label leftAlign"
            >
              Unsolicited Proposals Allowed
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="unsolicited_proposal_allowed"
                id="unsolicited_proposal_allowed"
                defaultValue={this.item.unsolicited_proposal_allowed}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="request_for_competing_bids"
              className="col-sm-3 col-form-label leftAlign"
            >
              Request For Competing Bids
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="request_for_competing_bids"
                id="request_for_competing_bids"
                defaultValue={this.item.request_for_competing_bids}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="p3_proposal_evaluation_criteria"
              className="col-sm-3 col-form-label leftAlign"
            >
              P3 Proposal Evaluation Criteria
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="p3_proposal_evaluation_criteria"
                id="p3_proposal_evaluation_criteria"
                defaultValue={this.item.p3_proposal_evaluation_criteria}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="addresses_confidentiality_of_bidders_proposal_info"
              className="col-sm-3 col-form-label leftAlign"
            >
              Addresses Confidentiality of Bidder's Proposal Info
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="addresses_confidentiality_of_bidders_proposal_info"
                id="addresses_confidentiality_of_bidders_proposal_info"
                defaultValue={
                  this.item.addresses_confidentiality_of_bidders_proposal_info
                }
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="payment_to_unsuccessful_bidders"
              className="col-sm-3 col-form-label leftAlign"
            >
              Payment to Unsuccessful Bidder For Proposal Material
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="payment_to_unsuccessful_bidders"
                id="payment_to_unsuccessful_bidders"
                defaultValue={this.item.payment_to_unsuccessful_bidders}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="proposal_review_fees"
              className="col-sm-3 col-form-label leftAlign"
            >
              Proposal Review Fees
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="proposal_review_fees"
                id="proposal_review_fees"
                defaultValue={this.item.proposal_review_fees}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="multiple_type_procurement"
              className="col-sm-3 col-form-label leftAlign"
            >
              Multiple Types of Procurement
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="multiple_type_procurement"
                id="multiple_type_procurement"
                defaultValue={this.item.multiple_type_procurement}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="exempt_p3_from_other_state_procurement_laws"
              className="col-sm-3 col-form-label leftAlign"
            >
              Exempts P3 From Other State Procurement Laws
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="exempt_p3_from_other_state_procurement_laws"
                id="exempt_p3_from_other_state_procurement_laws"
                defaultValue={
                  this.item.exempt_p3_from_other_state_procurement_laws
                }
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="opportunities_for_public_comment_hearing"
              className="col-sm-3 col-form-label leftAlign"
            >
              Opportunities For Public Comment or Hearing
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="opportunities_for_public_comment_hearing"
                id="opportunities_for_public_comment_hearing"
                defaultValue={
                  this.item.opportunities_for_public_comment_hearing
                }
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="information_addressing_toll_rate_setting"
              className="col-sm-3 col-form-label leftAlign"
            >
              Information Addressing Toll Rate-setting
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="information_addressing_toll_rate_setting"
                id="information_addressing_toll_rate_setting"
                defaultValue={
                  this.item.information_addressing_toll_rate_setting
                }
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="toll_revenue_bonds"
              className="col-sm-3 col-form-label leftAlign"
            >
              Toll Revenue Bonds
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="toll_revenue_bonds"
                id="toll_revenue_bonds"
                defaultValue={this.item.toll_revenue_bonds}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="surety_bonds"
              className="col-sm-3 col-form-label leftAlign"
            >
              Surety Bonds
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="surety_bonds"
                id="surety_bonds"
                defaultValue={this.item.surety_bonds}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="revenue_sharing_explicity_allowed"
              className="col-sm-3 col-form-label leftAlign"
            >
              Revenue Sharing Explicitly Allowed
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="revenue_sharing_explicity_allowed"
                id="revenue_sharing_explicity_allowed"
                defaultValue={this.item.revenue_sharing_explicity_allowed}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="limits_use_of_p3_project_revenue"
              className="col-sm-3 col-form-label leftAlign"
            >
              Limits Use of P3 Project Revenue
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="limits_use_of_p3_project_revenue"
                id="limits_use_of_p3_project_revenue"
                defaultValue={this.item.limits_use_of_p3_project_revenue}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="requires_p3_comparative_analysis"
              className="col-sm-3 col-form-label leftAlign"
            >
              Requires P3 Comparative Analysis
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="requires_p3_comparative_analysis"
                id="requires_p3_comparative_analysis"
                defaultValue={this.item.requires_p3_comparative_analysis}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="source"
              className="col-sm-3 col-form-label leftAlign"
            >
              Source
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="source"
                id="source"
                defaultValue={this.item.source}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="notes"
              className="col-sm-3 col-form-label leftAlign"
            >
              Notes
            </label>
            <div className="col-md-6">
              <textarea
                className="form-control"
                rows="3"
                name="notes"
                maxLength="4000"
                id="notes"
                defaultValue={this.item.notes}
                onChange={this.handleChange}
                disabled={!isAdmin}
              />
            </div>
          </div>

          <div className="form-group row">
            <label
              htmlFor="is_applied_any_state_gov_agency"
              className="col-sm-3 leftAlign required"
            >
              Applied by Any State Gov Agency
            </label>
            <div className="col-md-2 my-2">
              <select
                name="is_applied_any_state_gov_agency"
                id="is_applied_any_state_gov_agency"
                required
                className="form-control"
                defaultValue={
                  this.item.is_applied_any_state_gov_agency || "false"
                }
                onChange={this.handleChange}
                disabled={!isAdmin}
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
          </div>

          {isAdmin ? (
          <div className="form-group row">
            <button type="submit" className="btn btn-primary mx-2">
              Submit
            </button>
            <button
              className="btn btn-secondary"
              onClick={this.props.closeModalHandler}
            >
              Cancel
            </button>
          </div> ) : null }
        </form>
      </div>
    );
  }
}
export default LegislationModal;
